import React from 'react';
import { Elements } from 'react-stripe-elements';
import { Context } from '../../Context';
import CardDetails from '../CardDetails';
import { Paper, Typography, Grid, FormControlLabel, FormControl, FormLabel, Button, CircularProgress, Radio, RadioGroup } from '@material-ui/core/';
import PaymentMethodStyles from '../../Styles/PaymentMethodStyles';
import { withStyles } from '@material-ui/core/styles';
import { Mixpanel } from '../../Config/mixpanel';
import { Redirect } from 'react-router-dom';


class PaymentMethods extends React.Component {

	constructor() {
		super();
		this.state = { saved: false };
	}

	componentDidMount() {
		Mixpanel.track('Viewed page payment methods');
		if (!this.context.state.user) {
			this.context.actions.getUserProfile();
		}
	}

	handlePaymentDetailsChange = event => {
		this.context.actions.updateUserProfile({
			paymentMethod: event.target.value
		});
	}

	handleSave = event => {
		Mixpanel.track('Save attempt payment methods');

		if (this.context.state.user.paymentMethod === 'card' && (!this.context.state.user.stripe || !this.context.state.user.stripe.sources || this.context.state.user.stripe.sources.total_count === 0)) {
			window.alert('Please add a new card and save again.');
			return;
		} else {
			Mixpanel.track('Saving payment methods', { user: this.context.state.user });
			this.context.actions.saveUserProfile();
			this.setState({ saved: true });
		}
	}

	render() {
		const { classes } = this.props;
		const { user } = this.context.state;

		if (this.state.saved) {
			return (<Redirect to='/account' />)
		}

		let cards = [];
		if (user && user.stripe && user.stripe.sources.total_count > 0) {
			cards = user.stripe.sources.data;
		}

		return (
			<div className={classes.main}>
				{(this.context.state.loading || !user)
					? (<CircularProgress size={24} className={classes.progress} />)
					: <Paper className={classes.paper}>
						<Grid container spacing={3}>
							<Grid item xs={12}>
								<Typography variant="h4">
									Payment Methods
								</Typography>
								{/* <Typography variant="subtitle1">
									With Vimma you can select to pay by card or by bank transfer.
								</Typography> */}
							</Grid>
							<Grid item xs={12} style={{ textAlign: 'left' }}>
								<FormControl component="fieldset">
									<FormLabel component="legend">With Vimma you can select to pay by card or by bank transfer.</FormLabel>
									<RadioGroup
										aria-label="caption"
										name="caption"
										value={user.paymentMethod}
										onChange={this.handlePaymentDetailsChange}
									>
										<FormControlLabel value="card" control={<Radio color='primary' />} label="Pay with card" />
										<FormControlLabel value="invoice" control={<Radio color='primary' />} label="Pay by bank transfer" />
									</RadioGroup>
								</FormControl>

							</Grid>
							<Grid item xs={12}>
								{this.context.state.user.paymentMethod === 'card' && (
									<Grid container spacing={3}>
										<Grid item xs={12}>
											<Typography variant="h6" className={classes.typography}>
												Cards
											</Typography>
										</Grid>
										<Grid item xs={12}>
											{cards.length === 0 && (
												<Typography variant="subtitle1" className={classes.typography}>
													No cards saved yet, please add a new one.
												</Typography>
											)}
											<Grid container spacing={0}>
												{cards.map(card => (
													<Grid item xs={12} md={6} key={card.id}>
														<Paper className={classes.paper}>
															<Grid container spacing={1}>
																<Grid item xs={12}>
																	<Typography variant='subtitle2'>{card.card.brand} •••• {card.card.last4}</Typography>
																</Grid>
																<Grid item xs={12}>
																	<Typography variant='caption'>Expiry: {`${card.card.exp_month}/${card.card.exp_year}`}</Typography>
																</Grid>
															</Grid>
														</Paper>
													</Grid>

												))}
											</Grid>
										</Grid>
										<Grid item xs={12}>
											<Typography variant="h6" className={classes.typography}>
												Add new card
											</Typography>
										</Grid>
										<Grid item xs={12}>
											<Elements>
												<CardDetails />
											</Elements>
										</Grid>
									</Grid>
								)}
							</Grid>
							<Grid item xs={12} >
								<Button onClick={this.handleSave} variant="contained" size="large" color="primary">
									Save
      							</Button>
							</Grid>
						</Grid>
					</Paper>}
			</div>

		);
	}
}

PaymentMethods.contextType = Context;

export default withStyles(PaymentMethodStyles)(PaymentMethods);
